import { Observable, BehaviorSubject, combineLatest, of } from "rxjs";
import { switchMap, shareReplay, map, filter, tap } from "rxjs/operators";

export class ContentRefreshHelper {
    private readonly _refresh = new BehaviorSubject<boolean>(true);
    private readonly cache = new BehaviorSubject<any[]>([]);

    public readonly refresh$ = this._refresh.asObservable();

    public readonly data$ = this.refresh$.pipe(
        switchMap(() => this.source$),
        tap({
            next: (data) => this.cache.next(data),
            error: (error) => this.cache.error(error),
            complete: () => this.cache.complete()
        }),
        shareReplay()
    );

    public readonly count$ = this.data$.pipe(
        map(sources => sources?.length || 0),
        shareReplay()
    );

    get count() {
        return this.cache.value?.length || 0;
    }

    constructor(public readonly source$: Observable<any>, private readonly config: Partial<{ key: string }> = { key: 'id' }) { }


    refresh() {
        this._refresh.next(true);
    }

}
